import "./about.scss"
import { useState, useEffect }  from 'react';
import skillsData from '../../content.json';

const SkillButton = ({data}) => {
    if(data.url){
        return(
            <a className="skills-block btn btn-default" href={data.url} rel="noreferrer" target={"_blank"} title={`Open ${data.url} in new tab.`}>
                <img className="img-responsive" src={`/images/logos/${data.alt}`} alt={data.alt}/>
                <p>{data.title}</p>
            </a>
        )
    }
    else{
        return(
            <button className="skills-block btn btn-default" onClick={() => {document.getElementById("skills-container").scrollIntoView()}}>
                <img className="img-responsive" src={`/images/logos/${data.alt}`} alt={data.alt}/>
                <p>{data.title}</p>
            </button>
        )
    }
    
}
export default function About() {
    const skillsJson = skillsData.skills;
    const [skillsHtml, setSkillsHtml] = useState();

    useEffect(() => {
        const finalHtml = skillsJson.map((data,i) => {
            const insideHtml = data.data.map((data2,i2) => {
                return (<SkillButton data={data2} key={`skill-button-${i2}`}/>);
            });

            return (<div className={`col-12 col-lg-4 ${data.title}-block block-${i}`} key={`block-${i}`}>
                        <p className={`subtitle text-capitalize ${data.title}-text`}>{data.title}</p>
                        {insideHtml}
                    </div>
            )
        });
        setSkillsHtml(finalHtml)
    }, [skillsJson])

    return (
        <div className="about sections-page sections-page-2" id="about">
            <div className="container about-landing-container">
                <div className="row">
                    <div className="col-12 d-sm-none sm-title">
                        <p className="mb-0">About</p>
                    </div>
                    <div className="col-12 col-lg-5">
                        <div className="image-container">
                            <img className="img-responsive img-front" src="/images/about-1b.png" alt="about-2.png"/>
                            <img className="img-responsive img-back" src="/images/about-2b.png" alt="about-1.png"/>
                        </div>
                    </div>
                    <div className="col-12 col-lg-7 text-container position-relative">
                        <div className="text-group">
                            <object className="zigzag-divider" data="/images/zigzag-lines-u.svg"  alt="zigzag-lines.svg"  title="zigzag-lines.svg">  </object>
                            
                            <div className="about-text">
                                <span className="about-title h1">I'm <span className="about-name">Kelvin Calinisan</span>,</span>
                                <span className="h5"> a passionate front-end web developer who's always interested about cool stuff. I also enjoy graphic editing making me like both designing and coding, so being a Front-End Developer is a perfect mix of both. Logic and creativity should always coexist.</span>
                            </div>
                            
                            <div className="about-text">
                                <span className="h5" hidden>Always been a great team player and independent worker. Also been accepting freelance work on the side since the pandemic started. Some logos for small businesses, invitations and a WordPress Website.</span>
                                {/* <div className="cv-button-container">
                                    <a className="about-cv-button btn btn-primary" href="/John-Kelvin-Calinisan-Resume-qr-2022.pdf" title="Download CV" download><i className="fas fa-file-download"></i> Download CV</a>
                                </div> */}
                            </div>
                            <object className="zigzag-divider" data="/images/zigzag-lines.svg"  alt="zigzag-lines.svg"  title="zigzag-lines.svg">  </object>
                        </div>
                    </div>
                    <div className="col-12 text-center skills-container" id="skills-container">
                        <p className="title">Skills</p>
                        <div className="row">
                            {skillsHtml}
                        </div>
                    </div>
                </div>
            </div>
            <div className="parallax-background"></div>
        </div>
    )
}
